       
export function createXLSheetdata(kitchenList) {
    kitchenList.find((ticketDetails, index) => {
                
            delete kitchenList[index]['id']          

            kitchenList[index].ExEmployeeCode=kitchenList[index].ex_code
            delete kitchenList[index]['ex_code']

            kitchenList[index].EmployeeName=kitchenList[index].employee_name
            delete kitchenList[index]['employee_name']


            kitchenList[index].EmployeeId=kitchenList[index].employee_id
            delete kitchenList[index]['employee_id']

            kitchenList[index].City=kitchenList[index].city_name
            delete kitchenList[index]['city_name']
            

            kitchenList[index].RehiredDate=kitchenList[index].rehired_date
            delete kitchenList[index]['rehired_date']

            
            kitchenList[index].ReasonName=kitchenList[index].reason_name
            delete kitchenList[index]['reason_name']
            
            kitchenList[index].Remarks=kitchenList[index].remarks
            delete kitchenList[index]['remarks']
            
            kitchenList[index].CreatedOn=kitchenList[index].created
            delete kitchenList[index]['created']

            kitchenList[index].CreatedBy=kitchenList[index].created_by
            delete kitchenList[index]['created_by']


           
            return false

            })   
            return kitchenList
}



// WEBPACK FOOTER //
// ./src/modules/Employee Rehire/services/helpers.js